import React from 'react';
import styled from 'styled-components';

const MainMarker = () => {
  return (
    <Root src={require('src/assets/images/icons/ivy.svg')}>
    </Root>
  );
};

const Root = styled.img`
transform: translate(-50%,-50%)
`;

export default MainMarker;



// WEBPACK FOOTER //
// ./src/pages/Neighbourhood/elements/Map/elements/MainMarker.js